/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationAtsAutomationSettingsShowPathParams,
	OrganisationAtsAutomationSettingsShowResponse,
} from '../types/OrganisationAtsAutomationSettingsShow'

/**
 * GET /organisations/:organisation/ats-automation-settings
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAtsAutomationSettingsController.php OrganisationAtsAutomationSettingsController::show
 */
export async function organisationAtsAutomationSettingsShow(
	organisation: OrganisationAtsAutomationSettingsShowPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationAtsAutomationSettingsShowResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/ats-automation-settings`, config)
}
